import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { useMemo } from 'react';
import { getMessageText } from "../../../../../lib";
var checkMessage = function checkMessage(message, keyString) {
  var _getMessageText;
  return !!((_getMessageText = getMessageText(message)) !== null && _getMessageText !== void 0 && _getMessageText.toLowerCase().includes(keyString));
};

// Сортировка по возрастанию и убыванию
// const inverseSort: Record<string, number> = {
//   1: -1,
//   0: 0,
//   '-1': 1,
// };

// const sortMessages = (messages: Message[], sortType: SortingType) => {
//   if (sortType === 'none') {
//     return messages;
//   }

//   return messages.sort((a, b) => {
//     const sortFlag = a.date.localeCompare(b.date);
//     return sortType === 'asc' ? sortFlag : inverseSort[sortFlag];
//   });
// };

export var useSortedMessages = function useSortedMessages(_ref) {
  var sessions = _ref.sessions,
    search = _ref.search,
    _ref$sortType = _ref.sortType,
    sortType = _ref$sortType === void 0 ? 'none' : _ref$sortType;
  return useMemo(function () {
    var includedMessages = [];
    sessions.forEach(function (session) {
      if (search) {
        includedMessages.push.apply(includedMessages, _toConsumableArray(session.messages.filter(function (message) {
          return checkMessage(message, search);
        })));
      }
    });
    var includedIds = includedMessages.sort(function (a, b) {
      return a.date > b.date ? 1 : -1;
    }).map(function (_ref2) {
      var messageId = _ref2.messageId;
      return messageId.toString();
    }).reverse();
    return {
      sessions: sessions,
      includedIds: includedIds
    };
  }, [sortType, search, sessions]);
};